"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformObject = exports.fetchSignedUrl = void 0;
var images_1 = require("../../../constants/images");
var store_1 = require("../../../store");
var generic_api_calls_1 = require("../../generic_api_calls");
var KEY_TRANSFORMERS = {
    billing_type: function (val) { return getBillingTypeLabel(val); },
    billing_module: function (val) { return getBillingModuleLabel(val); },
    zone_id: function (val) { return getZoneLabel(val); },
    regional_manager_id: function (val) { return fetchRegionalManagerLabel(val); },
};
var getBillingTypeLabel = function (value) {
    var _a;
    if (!value)
        return '--';
    var billingTypes = store_1.store.getState().appConfigList.billing_types;
    var match = billingTypes === null || billingTypes === void 0 ? void 0 : billingTypes.find(function (item) { return item.value === Number(value); });
    return (_a = match === null || match === void 0 ? void 0 : match.label) !== null && _a !== void 0 ? _a : '--';
};
var getBillingModuleLabel = function (value) {
    var _a;
    if (!value)
        return '--';
    var billingModules = store_1.store.getState().appConfigList.billing_modules;
    var match = billingModules === null || billingModules === void 0 ? void 0 : billingModules.find(function (item) { return item.value === Number(value); });
    return (_a = match === null || match === void 0 ? void 0 : match.label) !== null && _a !== void 0 ? _a : '--';
};
var getZoneLabel = function (zone_id) {
    if (zone_id) {
        var regionalManagers = store_1.store.getState().appConfigList.regional_managers;
        var regionalManager = regionalManagers.find(function (zoneDetails) { return zoneDetails.id === zone_id; });
        return regionalManager && regionalManager.zone ? regionalManager.zone : '--';
    }
};
var fetchRegionalManagerLabel = function (value) {
    if (value) {
        var regionalManagers = store_1.store.getState().appConfigList.regional_managers;
        var regionalManager = regionalManagers.find(function (zoneDetails) { return zoneDetails.regional_manager_id === value; });
        return regionalManager && regionalManager.label ? regionalManager.label : '--';
    }
};
var fetchSignedUrl = function (value) { return __awaiter(void 0, void 0, void 0, function () {
    var docDetails, document, fileName, res, signedUrl;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                docDetails = {
                    imageUrl: '',
                    uploadedUrl: '',
                    documentName: ''
                };
                document = value ? value.split('/') : [];
                fileName = document[document.length - 1];
                if (!fileName)
                    return [2, docDetails];
                return [4, (0, generic_api_calls_1.fetchImnageURLFromName)(value)];
            case 1:
                res = _c.sent();
                signedUrl = (_b = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.url;
                docDetails.documentName = fileName;
                if (fileName.includes('jpg') || fileName.includes('png') || fileName.includes('jfif')) {
                    docDetails.imageUrl = signedUrl;
                    docDetails.uploadedUrl = signedUrl;
                }
                else if (fileName.includes('pdf')) {
                    docDetails.imageUrl = images_1.default.pdfImage;
                    docDetails.uploadedUrl = signedUrl;
                }
                else {
                    docDetails.imageUrl = images_1.default.csvImage;
                    docDetails.uploadedUrl = signedUrl;
                }
                return [2, docDetails];
        }
    });
}); };
exports.fetchSignedUrl = fetchSignedUrl;
var transformObject = function (obj) {
    if (Array.isArray(obj))
        return obj.map(function (item) { return (0, exports.transformObject)(item); });
    if (obj !== null && typeof obj === 'object') {
        return Object.entries(obj).reduce(function (acc, _a) {
            var key = _a[0], value = _a[1];
            if (value !== null && typeof value === 'object' && !Array.isArray(value)) {
                acc[key] = (0, exports.transformObject)(value);
            }
            else if (KEY_TRANSFORMERS[key]) {
                acc[key] = KEY_TRANSFORMERS[key](value);
            }
            else {
                acc[key] = value;
            }
            return acc;
        }, {});
    }
    return obj;
};
exports.transformObject = transformObject;
